import api from 'services/api';

export async function showPipeline({
  id,
  organizationId,
}: {
  id: string;
  organizationId: string;
}) {
  return api.get(`api/dashboard/organizations/${organizationId}/pipelines/${id}`);
}
